// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Container-module--bx--text-truncate--end--c_Clf";
export var bxTextTruncateFront = "Container-module--bx--text-truncate--front--l46Bz";
export var overlay = "Container-module--overlay--ngkfp";
export var visible = "Container-module--visible--TT02k";